export default __webpack_public_path__ + "static/media/ripple-1.ddf36abc.svg";